/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, Text, useSitecore } from '@sitecore-content-sdk/nextjs';
const getNavigationText = function(props) {
    let text;
    if (props.fields.NavigationTitle) {
        text = /*#__PURE__*/ _jsx(Text, {
            field: props.fields.NavigationTitle
        });
    } else if (props.fields.Title) {
        text = /*#__PURE__*/ _jsx(Text, {
            field: props.fields.Title
        });
    } else {
        text = props.fields.DisplayName;
    }
    return text;
};
const getLinkField = (props)=>({
        value: {
            href: props.fields.Href,
            title: getLinkTitle(props),
            querystring: props.fields.Querystring
        }
    });
export const Default = (props)=>{
    const [isOpenMenu, openMenu] = useState(false);
    const { page } = useSitecore();
    const styles = props.params != null ? `${props.params.GridParameters ?? ''} ${props?.params?.Styles ?? ''}`.trimEnd() : '';
    const id = props.params != null ? props.params.RenderingIdentifier : null;
    if (!Object.values(props.fields).length) {
        return /*#__PURE__*/ _jsx("div", {
            className: `component navigation ${styles}`,
            id: id ? id : undefined,
            children: /*#__PURE__*/ _jsx("div", {
                className: "component-content",
                children: "[Navigation]"
            })
        });
    }
    const handleToggleMenu = (event, flag)=>{
        if (event && page.mode.isEditing) {
            event.preventDefault();
        }
        if (flag !== undefined) {
            return openMenu(flag);
        }
        openMenu(!isOpenMenu);
    };
    const list = Object.values(props.fields).filter((element)=>element).map((element, key)=>/*#__PURE__*/ _jsx(NavigationList, {
            fields: element,
            handleClick: (event)=>handleToggleMenu(event, false),
            relativeLevel: 1
        }, `${key}${element.Id}`));
    return /*#__PURE__*/ _jsx("div", {
        className: `component navigation ${styles}`,
        id: id ? id : undefined,
        children: /*#__PURE__*/ _jsxs("label", {
            className: "menu-mobile-navigate-wrapper",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    type: "checkbox",
                    className: "menu-mobile-navigate",
                    checked: isOpenMenu,
                    onChange: ()=>handleToggleMenu()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "menu-humburger"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "component-content",
                    children: /*#__PURE__*/ _jsx("nav", {
                        children: /*#__PURE__*/ _jsx("ul", {
                            className: "clearfix",
                            children: list
                        })
                    })
                })
            ]
        })
    });
};
const NavigationList = (props)=>{
    const { page } = useSitecore();
    const [active, setActive] = useState(false);
    const classNameList = `${props?.fields?.Styles.concat('rel-level' + props.relativeLevel).join(' ')}`;
    let children = [];
    if (props.fields.Children && props.fields.Children.length) {
        children = props.fields.Children.map((element, index)=>/*#__PURE__*/ _jsx(NavigationList, {
                fields: element,
                handleClick: props.handleClick,
                relativeLevel: props.relativeLevel + 1
            }, `${index}${element.Id}`));
    }
    return /*#__PURE__*/ _jsxs("li", {
        className: `${classNameList} ${active ? 'active' : ''}`,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `navigation-title ${children.length ? 'child' : ''}`,
                onClick: ()=>setActive(()=>!active),
                children: /*#__PURE__*/ _jsx(Link, {
                    field: getLinkField(props),
                    editable: page.mode.isEditing,
                    onClick: props.handleClick,
                    children: getNavigationText(props)
                })
            }),
            children.length > 0 ? /*#__PURE__*/ _jsx("ul", {
                className: "clearfix",
                children: children
            }) : null
        ]
    }, props.fields.Id);
};
const getLinkTitle = (props)=>{
    let title;
    if (props.fields.NavigationTitle?.value) {
        title = props.fields.NavigationTitle.value.toString();
    } else if (props.fields.Title?.value) {
        title = props.fields.Title.value.toString();
    } else {
        title = props.fields.DisplayName;
    }
    return title;
};
